import * as types from "./types";

const mutations = {
    [types.LOADING_INVOICES](state, value) {
        state.loading = value;
    },
    [types.GET_INVOICES_LIST](state, invoices) {
        state.invoices = invoices;
    },
    [types.GET_INVOICES_ID](state, invoiceId) {
        state.invoiceId = invoiceId;
    },
    [types.REMOVE_INVOICES](state, id) {        
        state.invoices = state.invoices.filter((x) => x.id !== id);        
    },
    [types.ADD_INVOICES](state, invoices) {        
        state.invoices.unshift(invoices);
    },
    [types.UPDATE_INVOICES](state, invoices) {        
        const invoicesIndex = state.invoices.findIndex((x) => x.id === invoices.id);
        state.invoices[invoicesIndex] = invoices;        
    },
    [types.RETURN_INVOICES](state, id) {        
        const invoicesIndex = state.invoices.findIndex((x) => x.id === id);
        state.invoices[invoicesIndex] = invoices;        
    },
    [types.LOADING_INVOICE_DOCUMENT](state, value) {
        state.docLoader = value;
    },
    [types.GET_INVOICE_DOCUMENT_LIST](state, documents) {
        state.documents = documents;
    },
    [types.REMOVE_INVOICE_DOCUMENT](state, id) {        
        state.documents = state.documents.filter((x) => x.id !== id);        
    },
};

export default mutations;